class GspBundleSelector extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.variantPrice = Number(this.dataset.variantPrice) || 0;
    this.radios = Array.from(this.querySelectorAll('.gsp-bundle-option__input'));
    this.syncing = false;

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.onTierSelect(radio));
    });

    this.quantityInputs().forEach((input) => {
      input.addEventListener('change', () => this.onQuantityChange(input));
    });

    if (window.gspEvents && this.productId) {
      this.unsubscribeVariant = window.gspEvents.subscribe(
        `${this.productId}__VARIANT_CHANGE`,
        (variant) => {
          if (variant && typeof variant.price === 'number') {
            this.variantPrice = variant.price;
            this.updatePrices();
          }
        }
      );
    }

    this.initTimer();
  }

  disconnectedCallback() {
    if (this.unsubscribeVariant) this.unsubscribeVariant();
    if (this.timerInterval) clearInterval(this.timerInterval);
  }

  quantityInputs() {
    return Array.from(
      document.querySelectorAll(`input[name="quantity"][data-product-id="${this.productId}"]`)
    );
  }

  onTierSelect(radio) {
    if (this.syncing) return;
    const qty = Number(radio.dataset.qty) || 1;
    this.syncing = true;
    this.quantityInputs().forEach((input) => {
      if (Number(input.value) !== qty) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    this.syncing = false;
  }

  onQuantityChange(input) {
    if (this.syncing) return;
    const qty = Number(input.value);
    // The discount tiers are "minimum quantity" rules, so the highest tier
    // with data-qty <= qty is the one Shopify will actually apply.
    let best = null;
    this.radios.forEach((r) => {
      const tierQty = Number(r.dataset.qty);
      if (tierQty <= qty && (!best || tierQty > Number(best.dataset.qty))) {
        best = r;
      }
    });
    this.syncing = true;
    if (best) {
      best.checked = true;
    } else {
      this.radios.forEach((r) => {
        r.checked = false;
      });
    }
    this.syncing = false;
  }

  formatMoney(cents) {
    if (window.gspTheme && window.gspTheme.helper && window.gspSetting) {
      return window.gspTheme.helper.formatMoney(cents, window.gspSetting.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  updatePrices() {
    const freeShippingMin = Number(this.dataset.freeShippingMin) || 0;
    this.radios.forEach((radio) => {
      const option = radio.closest('.gsp-bundle-card');
      if (!option) return;
      const qty = Number(radio.dataset.qty) || 1;
      const percent = Number(radio.dataset.percent) || 0;
      const fullTotal = this.variantPrice * qty;
      const discTotal = Math.round((fullTotal * (100 - percent)) / 100);
      const priceNode = option.querySelector('[data-bundle-price]');
      const compareNode = option.querySelector('[data-bundle-compare]');
      const perNode = option.querySelector('[data-bundle-per]');
      const saveNode = option.querySelector('[data-bundle-save]');
      const shippingNode = option.querySelector('[data-bundle-shipping]');
      if (priceNode) priceNode.innerHTML = this.formatMoney(discTotal);
      if (compareNode) compareNode.innerHTML = this.formatMoney(fullTotal);
      if (perNode) perNode.innerHTML = this.formatMoney(Math.round(discTotal / qty));
      if (saveNode) saveNode.innerHTML = this.formatMoney(fullTotal - discTotal);
      if (shippingNode && freeShippingMin > 0) shippingNode.hidden = discTotal < freeShippingMin;
    });
  }

  initTimer() {
    const timer = this.querySelector('[data-bundle-timer]');
    if (!timer) return;
    const endsAt = Date.parse(timer.dataset.endsAt);
    if (Number.isNaN(endsAt)) return;
    const valueNode = timer.querySelector('[data-bundle-timer-value]');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = endsAt - Date.now();
      if (left <= 0) {
        timer.hidden = true;
        clearInterval(this.timerInterval);
        return;
      }
      const days = Math.floor(left / 86400000);
      const hours = Math.floor((left % 86400000) / 3600000);
      const minutes = Math.floor((left % 3600000) / 60000);
      const seconds = Math.floor((left % 60000) / 1000);
      let text = `${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;
      if (days > 0) text = `${days}d : ${text}`;
      valueNode.textContent = text;
      timer.hidden = false;
    };
    tick();
    this.timerInterval = setInterval(tick, 1000);
  }
}

if (!customElements.get('gsp-bundle-selector')) {
  customElements.define('gsp-bundle-selector', GspBundleSelector);
}
